export default __webpack_public_path__ + "static/media/ensemble.c41883d1.jpg";